export const GET_LEAD_ACTIVITIES_DETAIL_API =
  'thor/v2/crm/listing-performance/lead-activities/report/details';
